import React, { useState } from 'react'
import Lightbox from 'yet-another-react-lightbox'
import 'yet-another-react-lightbox/styles.css'

interface QuestionImageProps {
  url: string | null | undefined
  imgStyle?: React.CSSProperties
}
export const QuestionImage = (props: QuestionImageProps) => {
  const { url, imgStyle } = props
  const [open, setOpen] = useState(false)

  if (!url) {
    return null
  }

  return (
    <>
      <Lightbox
        open={open}
        close={() => setOpen(false)}
        slides={[{ src: url || '' }]}
        render={{
          buttonPrev: () => null,
          buttonNext: () => null,
        }}
      />
      <img onClick={() => setOpen(true)} style={{ ...IMG, ...imgStyle }} src={url} />
    </>
  )
}
const IMG: React.CSSProperties = {
  borderRadius: 16,
  display: 'block',
  objectFit: 'contain',
  cursor: 'zoom-in',
}
